import template from './employee_add_manager_department.html';
import tr from '../../lib/default-translator.js';

class EmployeeAddManagerDepartmentViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.department_id = ko.observable();
		this.available_departments = ko.observableArray();
		this.employee_id = ko.observable();
	};

	async save_manager_department()
	{
		let data = {
			employee_id: this.dialog.bindings.employee_id,
			department_id: this.department_id()
		};

		let res = await Grape.fetches.postJSON('/employee/save_manager_department', data);
		
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully saved.', 'Successfully saved.'), title: tr('Success', 'Success')});
			this.dialog.close(true);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};

	close()
	{
		this.dialog.close(false);
	};
};

class EmployeeAddManagerDepartmentPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeAddManagerDepartmentViewModel(this);
		this.bindings = bindings;
		this.viewModel.employee_id(bindings.employee_id);
	};

	async init()
	{
		let option = {
			employee_id: this.viewModel.employee_id()
		};

		let res = await Grape.fetches.postJSON('/employee/get_manager_department_selection', option);
		this.viewModel.available_departments(res);
	};
};

export default {
	name: 'EmployeeAddManagerDepartment',
	dialog_class: EmployeeAddManagerDepartmentPage,
	template: template,
	template_filename: 'translation/dialogs/employee_add_manager_department',
	provider: 'ps'
};
